import WidgetData from '../Interfaces/WidgetData';

const WidgetDataState: WidgetData[] = [];

export default WidgetDataState;
